import React, {Component} from 'react'
import ReactTable from "react-table";
import * as config from '../Configuration/Config.js'

class VisualizationsGrid extends Component {
    constructor() {
        super();

        this.state = {
            loaded: false,
            visualizations: []
        }
    }

    componentDidMount() {
        var that = this;

        const uri = config.getUriPath('visualizations')
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }
            return response.json();
          })
          .then(function(data) {
            that.setState({ loaded: true, visualizations: data });
          });
    }

    render() {

        if (this.state.loaded === false){
            return <div></div>;
        }

        const visualizations = this.state.visualizations;

        if (visualizations === null || visualizations.length === 0) {
            return <div>
                    <div className="center-div">
                        <h1>All Visualizations</h1>
                    </div>
                    <br/><br/>
                    <h1>No Visualizations Found</h1>                
            </div>
        }

        // const Header = ["Visualization Name" ];
        return <div>
                <div className="center-div">
                    <h1>All Visualizations</h1>
                </div>
                <br/><br/>
                <div className="ReactTableCenter center-div">
                    <ReactTable
                        data={visualizations}                        
                        columns={[
                            {
                                Header: "Visualization Name",
                                id: "id",
                                accessor: 'display_name',
                                Cell: (row) => 
                                    <span className="center-div">
                                        <a href={"/visualizations/view/" + row.original.id + "/" + row.original.group_id}>{row.original.display_name}</a>
                                    </span>                                
                            }
                        ]}
                        defaultPageSize={visualizations.length}
                        showPagination={false}
                        //defaultPageSize={15}
                        className="-striped -highlight"
                    >
                    </ReactTable>
                </div>
        </div>
    }
}

export default VisualizationsGrid


// WEBPACK FOOTER //
// ./src/Components/Visualizations/VisualizationsGrid.js